
export default function ProgramsHero() {
  return (
    <section 
      className="relative py-24 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/d22d8b3d18fa473b3fc32e93477792e6.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Soccer Programs
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
          Comprehensive training programs designed for every age and skill level
        </p>
      </div>
    </section>
  );
}
